import $ from 'jquery';
import 'slick-carousel';

const SpecificationSlider = () => {
  const specifications = $('.specifications__row');
  let sliderInitialized = false; // Flag to track whether the slider is initialized

  const initializeSlider = () => {
    if ($(window).width() <= 768 && !sliderInitialized) {
      // Initialize the slider if the window width is less than or equal to 768
      specifications.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
      sliderInitialized = true;
    } else if ($(window).width() > 768 && sliderInitialized) {
      // Unslick (destroy) the slider if the window width is greater than 768
      specifications.slick('unslick');
      sliderInitialized = false;
    }
  };

  // Initial setup on page load
  initializeSlider();

  // Attach event listener to window resize
  $(window).on('resize', () => {
    initializeSlider();
  });
};

export default SpecificationSlider;
